var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"m-input price-input price-field"},[_c('m-text-field',_vm._b({ref:"inputRef",attrs:{"append-icon":_vm.currencyIcons,"type":"text"}},'m-text-field',_vm.$attrs,false))],1)}
var staticRenderFns = []

export { render, staticRenderFns }